import { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  height: 394px;
  width: 800px;
  padding: 30px;
  box-shadow: 0px 1px 30px rgba(85, 85, 85, 0.1);
  border-radius: 30px;
`

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  max-width: 580px;
  min-height: 100%;
  align-items: center;
  justify-content: center;
`

const StyledImgLogin = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
  width: 234px;
  border-radius: 16px;
`

const LogScreen: FC = ({ children }) => {
  return (
    <Container>
      <Wrapper>{children}</Wrapper>
      <StyledImgLogin
        src="/images/pg-logo-screen.png"
        alt=""
        className="bg-image"
      />
    </Container>
  )
}

export default LogScreen
